import {
  initialState,
  Actions,
  State,
  NEW_CUSTOMER,
  NEW_CUSTOMER_SUCCESS,
  NEW_CUSTOMER_ERROR,
  RESET_NEW_CUSTOMER,
} from '../../types/customer/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CUSTOMER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_CUSTOMER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_CUSTOMER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_CUSTOMER:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
